import { colors, breakpoints, getRgbaColor } from '@web-for-marketing/react-ui';

export const SubscriptionBoxStyles = {
    boxContainer: {
        padding: '4rem',
        borderRadius: '8px',
        backgroundColor: colors.action.innovationDark,
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '2.4rem',
        },
    },
    shortBoxContainer: {
        padding: '3.2rem',
        borderRadius: '8px',
        backgroundColor: colors.action.innovationDark,
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '2.4rem',
        },
    },
    description: {
        marginBottom: '1.6rem',
        color: colors.text.inversePrimary,
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginBottom: '1.2rem',
        },
    },
    title: {
        marginBottom: '1.6rem',
        color: colors.text.inversePrimary,
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginBottom: '1.2rem',
        },
    },
    inputTextboxContainer: {
        width: '100%',
        flexGrow: 1,
    },
    input: {
        '& > div': {
            borderRadius: '6px',
        },
    },
    consentContainer: {
        width: '100%',
        padding: '0.8rem 0 2.4rem 1.8rem',
        flexDirection: 'row',
        '& span': {
            padding: 0,
        },
        '& svg': {
            fontSize: '2.2rem !important',
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '0.4rem 0 0.8rem 1.8rem',
        },
    },
    label: {
        color: colors.core.snow,
        fontSize: '1.4rem',
        '& a': {
            color: colors.core.snow,
        },
        '& a:hover': {
            backgroundColor: getRgbaColor(colors.core.snow, 0.02),
        },
        '& a:focus': {
            backgroundColor: `${getRgbaColor(colors.core.snow, 0.05)} !important`,
        },
    },
    linkStyles: {
        textDecoration: 'underline',
    },
} as const;
